var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Folder Open/Multicolour/Colourful") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin:-Shop/Empty",
    transform: "translate(-685, -287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lessons",
    transform: "translate(88, 162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(523, 125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_book_24dp_5F6368",
    transform: "translate(74, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 13.5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,1.5 C56.67,0.45 53.01,0 49.5,0 C43.65,0 37.35,1.2 33,4.5 C28.65,1.2 22.35,0 16.5,0 C10.65,0 4.35,1.2 0,4.5 L0,48.45 C0,49.2 0.75,49.95 1.5,49.95 C1.8,49.95 1.95,49.8 2.25,49.8 C6.3,47.85 12.15,46.5 16.5,46.5 C22.35,46.5 28.65,47.7 33,51 C37.05,48.45 44.4,46.5 49.5,46.5 C54.45,46.5 59.55,47.4 63.75,49.65 C64.05,49.8 64.2,49.8 64.5,49.8 C65.25,49.8 66,49.05 66,48.3 L66,4.5 C64.2,3.15 62.25,2.25 60,1.5 Z M60,42 C56.7,40.95 53.1,40.5 49.5,40.5 C44.4,40.5 37.05,42.45 33,45 L33,10.5 C37.05,7.95 44.4,6 49.5,6 C53.1,6 56.7,6.45 60,7.5 L60,42 Z",
    id: "Shape",
    fill: "#586179"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36, 13.5)",
    fill: "#393E4B",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,4.5 C16.14,4.5 18.69,4.77 21,5.28 L21,0.72 C18.63,0.27 16.08,0 13.5,0 C8.4,0 3.78,0.87 0,2.49 L0,7.47 C3.39,5.55 8.1,4.5 13.5,4.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.47 L0,15.45 C3.39,13.53 8.1,12.48 13.5,12.48 C16.14,12.48 18.69,12.75 21,13.26 L21,8.7 C18.63,8.25 16.08,7.98 13.5,7.98 C8.4,7.98 3.78,8.88 0,10.47 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15.99 C8.4,15.99 3.78,16.86 0,18.48 L0,23.46 C3.39,21.54 8.1,20.49 13.5,20.49 C16.14,20.49 18.69,20.76 21,21.27 L21,16.71 C18.63,16.23 16.08,15.99 13.5,15.99 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.6941dcf9.svg";
export { ForwardRef as ReactComponent };